import { formatUnits } from 'ethers';

export function formatTokenAmount(raw: bigint, decimals: number, maxFractionDigits = 4): string {
  const full = formatUnits(raw, decimals);
  const [int, frac = ''] = full.split('.');
  if (!frac || maxFractionDigits === 0) return int ?? '0';
  const trimmed = frac.replace(/0+$/, '').slice(0, maxFractionDigits);
  return trimmed.length > 0 ? `${int}.${trimmed}` : (int ?? '0');
}

export function shortenAddress(address: string, head = 6, tail = 4): string {
  if (address.length <= head + tail + 2) return address;
  return `${address.slice(0, head + 2)}…${address.slice(-tail)}`;
}

export function formatFiat(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency}`;
  }
}
